/*------------------------------------------------------------------
Search Controller
------------------------------------------------------------------*/

class SearchController {
  constructor(form, button) {
    this.html = document.querySelector('html');
    this.form = form;
    this.button = button;
    this.active = false;
    this.button.addEventListener('click', () => this.toggle());
    window.addEventListener('click', e => this.clickToClose(e));
  }
  toggle() {
    this.active ? this.close() : this.open();
  }
  clickToClose(e) {
    if (!Meteora.relativeTarget(e.target, this.form) && !Meteora.relativeTarget(e.target, this.button)) {
      this.close();
    }
  }
  close() {
    this.active = false;
    this.html.classList.remove('search-form-active');
  }
  open() {
    this.active = true;
    this.html.classList.add('search-form-active');
    this.form.querySelector('input').focus();
  }
}
[...document.querySelectorAll('.js-search')].forEach(block => {
  const form = block.querySelector('.js-search__form');
  const button = block.querySelector('.js-search__button');
  if (!form || !button) return;
  new SearchController(form, button);
});